<template>
    <div class="consultation-header">
        <div class="header-first">
            <div style="text-align:center;font-family: Microsoft YaHei;font-weight: bold;color: #272727;margin-top:15px;font-size:22px"><span>专科联盟</span></div>
        </div>
        <div class="header-second">
            <div style="font-family: Microsoft YaHei;font-weight: bold;color: #4E4E4E;font-size:18px"><span>背景</span></div>
            <div style="font-family: Microsoft YaHei;font-weight: 400;color: #7D7D7D;margin-top:20px;text-indent:30px;"> 			专科联盟是一种以专科为着眼点的松散医疗联合体，由医疗机构特色专科技术力量为支撑，充分发挥医学中心、临床医学研究中心及其协同网络的
        </div>
            <div style="font-family: Microsoft YaHei;font-weight: 400;color: #7D7D7D;padding-top:10px">作用，以专科协作为纽带，形成补位发展模式，提升疾病救治能力。跨区域专科联盟成员的原有体制和运营机制保持不变，以专业技术作为联盟的核心纽
        </div>
            <div style="font-family: Microsoft YaHei;font-weight: 400;color: #7D7D7D;padding-top:10px;">带，以解决区域间医疗资源不平衡为着眼点。专科联盟的创新性体现在创设以专科为基础的合作共赢平台,打造医疗专科技术帮扶联盟和更针对性地培养专</div>
            <div style="font-family: Microsoft YaHei;font-weight: 400;color: #7D7D7D;padding-top:10px;">业人才。跨区域专科联盟有利于促进专科优质医疗资源的下沉、提升重大疾病防治能力以及快速提升应对专科疾病的整体服务能力。</div>
        </div>
        <div class="header-second" style="margin-top:20px">
            <div style="font-family: Microsoft YaHei;font-weight: bold;color: #4E4E4E;font-size:18px"><span>方案简介</span></div>
            <div style="font-family: Microsoft YaHei;font-weight: 400;color: #7D7D7D;margin-top:20px;text-indent:30px;">	专科联盟平台以支持专科医院或跨区域的重点专科服务基层医疗服务机构专科能力为目标，跨区域打通围绕该专科方向的核心医院和基层医院。提
        </div>
            <div style="font-family: Microsoft YaHei;font-weight: 400;color: #7D7D7D;padding-top:10px">供远程会诊、远程查房、手术示教、培训直播等方式，实现县级医院与重点专科医院之间的双向打通，让基层患者方便就医，同时也为基层医院培养专科 
        </div>
            <div style="font-family: Microsoft YaHei;font-weight: 400;color: #7D7D7D;padding-top:10px;">人才。</div>
            <div style="margin-top:25px;">
                <img src="@/assets/image/zhuanke.png" alt="">
            </div>
        </div>
        <div class="header-firth" style="margin-top:15px">
            <div style="font-family: Microsoft YaHei;font-weight: bold;color: #4E4E4E;font-size:18px"><span>方案框架</span></div>
            <div style="margin-top:20px">
                <img src="@/assets/image/zhuanke1.png" alt="">
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss">
    .consultation-header{
        width: 100%;
        padding-left: 20px;
        .header-forth{
            margin-right:70px;
        }

    }
</style>